module.exports = __webpack_public_path__ + "static/img/season-message-alert-character.1fa8920.png";